var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 12a47 47 0 11-37.96 74.713l18.98-13.857A23.5 23.5 0 1055 35.5V12z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.225 72.059c-.778.505-1.566.534-2.364.086-.796-.446-1.194-1.136-1.194-2.07v-24.15c0-.933.398-1.623 1.194-2.071.798-.447 1.586-.417 2.364.088l19.017 12.075c.7.467 1.05 1.128 1.05 1.984 0 .855-.35 1.516-1.05 1.983L48.225 72.059z",
    fill: "currentColor"
  })));
}
export default SvgProgressPlay;